export default {
    table : {
        itensPagina: 'Itens por Página: ',
        de: 'de'
    }
    
}
